import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: "#ee6daf",
        secondary: "#c084fc",
        accent: "#ee6daf",
        error: "#ef4444",
        background: "#19112b",
      },
    },
  },
});
